module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/shopper_avatar-bbf2edae.png";